import React, { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Aligment, Dropdown, Icon, Toogle } from "venice-ui";
import { IOptions } from "../../types/sectionTypes";
import { Tabs } from "../UI/Tabs";
import { dictionary } from "../../untils/dictionary";
import { t } from "../../helpers/userHelper";
import { Colors } from "../../untils/Theme";
import { zoomScale } from "./readerHelper";
import {
  MapHeaderWrapper,
  ZoomIcon,
  ZoomScale,
  ZoomSection,
} from "./Sections.styles";

const SectionWrapper = styled.div`
  width: 9.2rem;
  display: flex;
`;
interface IMapHeaderProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  activePage: number;
  pageCount: number;
  resetSelection: () => void;
  scale: number;
  updateScale: (direction: string) => void;
  showJointWeld: boolean;
  toogleShowJointWeld: (mode: boolean) => void;
}
export const MapHeader: FC<IMapHeaderProps> = ({
  activeTab = "map",
  setActiveTab,
  activePage,
  pageCount,
  resetSelection,
  scale,
  updateScale,
  showJointWeld,
  toogleShowJointWeld,
}) => {
  const navigate = useNavigate();
  const { sectionID, projectID } = useParams();
 

  const menuTabs = [
    {
      value: "map",
      label: t(dictionary.map),
    },
    {
      value: "list",
      label: t(dictionary.weldingLogSection),
    },
  ];
  const getPages = (count: number): IOptions[] => {
    const options = [];
    for (let i = 0; i < count; i++) {
      const obj = {
        label: (i + 1).toString(),
        value: i + 1,
      };
      options.push(obj);
    }
    return options;
  };



  const setPage = (name: string, value: number | string) => {
    resetSelection();
    navigate(`/project/${projectID}/${sectionID}/${value}`);
  };

  
  const isAvailableZoomOut = () => {
    let scaleIndex = zoomScale.findIndex((item) => item === scale);
    return scaleIndex > 0;
  };

  const isAvailableZoomIn = () => {
    let scaleIndex = zoomScale.findIndex((item) => item === scale);
    return scaleIndex < zoomScale.length - 1;
  };
  const formatScale = (scale: number): string => {
    const textScale = (scale * 100).toString();
    const splited = textScale.split(".");

    if (splited.length === 1) {
      return textScale;
    } else {
      return (scale * 100).toFixed(2);
    }
  };

  return (
    <MapHeaderWrapper>
      <Aligment justify="start-flex" width={"auto"} gap={16}>
        <Tabs tabs={menuTabs} activeValue={activeTab} onClick={setActiveTab} />
        {activeTab === "list" && (
          <>
            <Toogle
              handleClick={() => toogleShowJointWeld(!showJointWeld)}
              value={showJointWeld}
              size={"small"}
              label={t(dictionary.showConnectingWelds)}
              labelPosition={"left"}
            />
          </>
        )}
        {activeTab === "map" && (
          <>
            <ZoomSection>
              <ZoomScale>{formatScale(scale)}%</ZoomScale>
              <ZoomIcon>
                <Icon
                  name="zoom_in"
                  iconColor={Colors.appBlue}
                  iconHoverColor={Colors.seaBlue}
                  onClick={() => updateScale("up")}
                  size={16}
                  isDisabled={!isAvailableZoomIn()}
                  iconBgHoverColor="transparent"
                  iconBgColor="transparent"
                  tooltip={t(dictionary.zoomInTooltip)}
                />
              </ZoomIcon>
              <ZoomIcon>
                <Icon
                  name="zoom_out"
                  iconColor={Colors.appBlue}
                  iconHoverColor={Colors.seaBlue}
                  size={16}
                  onClick={() => updateScale("down")}
                  isDisabled={!isAvailableZoomOut()}
                  iconBgHoverColor="transparent"
                  tooltip={t(dictionary.zoomOutTooltip)}
                />
              </ZoomIcon>
              <ZoomIcon>
                <Icon
                  name="fit_to_screen"
                  iconColor={Colors.appBlue}
                  iconHoverColor={Colors.seaBlue}
                  size={16}
                  onClick={() => updateScale("fit")}
                  iconBgHoverColor="transparent"
                  tooltip={t(dictionary.fitToScreenTooltip)}
                />
              </ZoomIcon>
              <ZoomIcon>
                <Icon
                  name="orginal_size"
                  iconColor={Colors.appBlue}
                  iconHoverColor={Colors.seaBlue}
                  size={16}
                  onClick={() => updateScale("reset")}
                  iconBgHoverColor="transparent"
                  tooltip={t(dictionary.originalSizeTooltip)}
                />
              </ZoomIcon>
            </ZoomSection>
          </>
        )}
      </Aligment>
      {activeTab === "map" && (
        <>
          <Aligment width="auto" wrap="nowrap">
            
            <SectionWrapper>
              <Dropdown
                label={t(dictionary.page)}
                labelPosition="left"
                size="small"
                value={activePage}
                width="auto"
                options={getPages(pageCount)}
                handleSelect={setPage}
                name="pageSelector"
              />
            </SectionWrapper>
          </Aligment>
        </>
      )}
    </MapHeaderWrapper>
  );
};
